import type { ApolloClient } from '@apollo/client/core';
import { Specialization_ProductVariant } from '__generated__/graphql-types';

import S12nQuery from 'bundles/accomplishments/queries/GetS12nProductVariantQuery.graphql';
import type {
  GetS12nProductVariantQuery,
  GetS12nProductVariantQueryVariables,
} from 'bundles/accomplishments/queries/__generated__/GetS12nProductVariantQuery';

/**
 * Fetch the product variant of a specialization
 * @param s12nId Id of the specialization
 * @param apolloClient
 * @returns specializaiton product variant or default product variant
 */
export const getS12nProductVariantById = (
  s12nId: string,
  apolloClient: ApolloClient<unknown>
): Promise<Specialization_ProductVariant> => {
  const defaultProductVariant = Specialization_ProductVariant.NormalS12N;

  return apolloClient
    .query<GetS12nProductVariantQuery, GetS12nProductVariantQueryVariables>({
      query: S12nQuery,
      variables: {
        s12nid: s12nId,
      },
      context: {
        clientName: 'gatewayGql',
      },
    })
    .then((response) => response.data.Specialization?.queryById?.productVariant || defaultProductVariant)
    .catch(() => defaultProductVariant);
};
